import Ripple from 'choerodon-ui/lib/ripple';
export default Ripple;
